import {
    tn_banner_avif, tn_banner_mobile_avif, tn_banner_mobile_png, tn_banner_mobile_webp,
    tn_banner_png, tn_banner_webp,
    tn_dynamic_ads_avif,
    tn_dynamic_ads_mobile_avif,
    tn_dynamic_ads_mobile_png,
    tn_dynamic_ads_mobile_webp,
    tn_dynamic_ads_png,
    tn_dynamic_ads_webp,
    tn_html_avif,
    tn_html_mobile_avif,
    tn_html_mobile_png,
    tn_html_mobile_webp,
    tn_html_png,
    tn_html_webp
} from "../../assets/tn";
import {
    ng_banner_ads,
    ng_banner_ads_mobile,
    ng_banner_ads_mobile_webp,
    ng_banner_ads_webp, ng_dynamic_ads, ng_dynamic_ads_mobile, ng_dynamic_ads_mobile_webp, ng_dynamic_ads_webp,
    ng_html_ads, ng_html_ads_mobile, ng_html_ads_mobile_webp, ng_html_ads_webp
} from "../../assets";
import { mtn_ic_adaptive, mtn_ic_banner, mtn_ic_html } from "../../assets/mtn";

export const NG_FEATURES = [
    {
        id: 0,
        title: 'No Cookie dependency',
        description: 'Reduce the guesswork around targeting criteria and the miss match of user persona and targeting criteria other tools provide.',
        label: '01',
    },
    {
        id: 1,
        title: "Competitors' clients are just a click away",
        description: 'Win your competitors users, run loyalty and retention campaigns, segment users by their interests and the websites they browse.',
        label: '02',
    },
    {
        id: 2,
        title: 'The power of programmatic with the connection of voice',
        description: 'For the first time you can also target feature phone users with digital precision, with Airtel Ads’ exclusive Rewarded Voice Ads',
        label: '03',
    },
    {
        id: 3,
        title: 'Integration and Reporting API',
        description: 'Our API is available for integration with any analytics and reporting platform you may be using',
        label: '04',
    },
    {
        id: 4,
        title: 'Pay-as-you-go',
        description: 'Our pay-as-you-go model makes it easy for businesses of all sizes to access our expert ad technology and enjoy maximum ROI without breaking the bank.',
        label: '05',
    },
    {
        id: 5,
        title: <>360<span>&#176;</span> Support</>,
        description: 'We are committed to providing our clients with the best possible experience. Whether you need help setting up your account, optimizing your ads, or troubleshooting any issues, we are here to help.',
        label: '06',
    }
];
export const NG_AD_TYPES = [
    {
        id: 0,
        title: 'Banner Ads',
        description: 'Use JPEG or PNG files for each of the sizes recommended',
        image: tn_banner_png,
        imageWebp: tn_banner_webp,
        imageAvif: tn_banner_avif,
        alt: 'Banner Ads',
        mobImage: tn_banner_mobile_png,
        mobImageWebp: tn_banner_mobile_webp,
        mobImageAvif: tn_banner_mobile_avif,
        size: 183,
        mobSize: 120,
    },
    {
        id: 1,
        title: 'HTML',
        description: 'Create and upload animated banners',
        image: tn_html_png,
        imageWebp: tn_html_webp,
        imageAvif: tn_html_avif,
        alt: 'HTML Ads',
        mobImage: tn_html_mobile_png,
        mobImageWebp: tn_html_mobile_webp,
        mobImageAvif: tn_html_mobile_avif,
        size: 183,
        mobSize: 120,
    },
    {
        id: 2,
        title: 'Dynamic Ads',
        description: 'Reduce the manual work, input all the details and enjoy your dynamic ads generated for all the sizes.',
        image: tn_dynamic_ads_png,
        imageWebp: tn_dynamic_ads_webp,
        imageAvif: tn_dynamic_ads_avif,
        alt: 'Dynamic Ads',
        mobImage: tn_dynamic_ads_mobile_png,
        mobImageWebp: tn_dynamic_ads_mobile_webp,
        mobImageAvif: tn_dynamic_ads_mobile_avif,
        size: 183,
        mobSize: 120,
    },
    {
        id: 3,
        title: 'Rewarded Voice Ads',
        description: 'Now, you have the ability to precisely target feature phone users using digital technology for the first time, thanks to Airtel Ads',
        image: tn_dynamic_ads_png,
        imageWebp: tn_dynamic_ads_webp,
        imageAvif: tn_dynamic_ads_avif,
        mobImage: tn_dynamic_ads_mobile_png,
        mobImageWebp: tn_dynamic_ads_mobile_webp,
        mobImageAvif: tn_dynamic_ads_mobile_avif,
        alt: 'Voice Ads',
        size: 183,
        mobSize: 120,
    },
];

export const MTN_AD_TYPES = [
    {
        id: 0,
        title: 'Banner Ads',
        description: 'Use JPEG or PNG files for each of the sizes recommended',
        image: mtn_ic_banner,
        imageWebp: mtn_ic_banner,
        imageAvif: mtn_ic_banner,
        alt: 'Banner Ads',
        mobImage: mtn_ic_banner,
        mobImageWebp: mtn_ic_banner,
        mobImageAvif: mtn_ic_banner,
        size: 183,
        mobSize: 120,
    },
    {
        id: 1,
        title: 'HTML',
        description: 'Create and upload animated banners',
        image: mtn_ic_html,
        imageWebp: mtn_ic_html,
        imageAvif: mtn_ic_html,
        alt: 'HTML Ads',
        mobImage: mtn_ic_html,
        mobImageWebp: mtn_ic_html,
        mobImageAvif: mtn_ic_html,
        size: 183,
        mobSize: 120,
    },
    {
        id: 2,
        title: 'Dynamic Ads',
        description: 'Reduce the manual work, input all the details and enjoy your dynamic ads generated for all the sizes.',
        image: mtn_ic_adaptive,
        imageWebp: mtn_ic_adaptive,
        imageAvif: mtn_ic_adaptive,
        alt: 'Dynamic Ads',
        mobImage: mtn_ic_adaptive,
        mobImageWebp: mtn_ic_adaptive,
        mobImageAvif: mtn_ic_adaptive,
        size: 183,
        mobSize: 120,
    },
    {
        id: 3,
        title: 'Rewarded Voice Ads',
        description: 'Now, you have the ability to precisely target feature phone users using digital technology for the first time, thanks to Airtel Ads',
        image: mtn_ic_adaptive,
        imageWebp: mtn_ic_adaptive,
        imageAvif: mtn_ic_adaptive,
        mobImage: mtn_ic_adaptive,
        mobImageWebp: mtn_ic_adaptive,
        mobImageAvif: mtn_ic_adaptive,
        alt: 'Voice Ads',
        size: 183,
        mobSize: 120,
    },
];
export const AD_TYPES = [
    {
        id: 0,
        title: 'Banner Ads',
        description: 'Use JPEG or PNG files for each of the sizes recommended',
        image: ng_banner_ads,
        imageWebp: ng_banner_ads_webp,
        alt: 'Banner Ads',
        mobImage: ng_banner_ads_mobile,
        mobImageWebp: ng_banner_ads_mobile_webp,
        size: 183,
        mobSize: 120,
    },
    {
        id: 1,
        title: 'HTML',
        description: 'Create and upload animated banners',
        image: ng_html_ads,
        imageWebp: ng_html_ads_webp,
        alt: 'HTML Ads',
        mobImage: ng_html_ads_mobile,
        mobImageWebp: ng_html_ads_mobile_webp,
        size: 183,
        mobSize: 120,
    },
    {
        id: 2,
        title: 'Dynamic Ads',
        description: 'Reduce the manual work, input all the details and enjoy your dynamic ads generated for all the sizes.',
        image: ng_dynamic_ads,
        imageWebp: ng_dynamic_ads_webp,
        alt: 'Dynamic Ads',
        mobImage: ng_dynamic_ads_mobile,
        mobImageWebp: ng_dynamic_ads_mobile_webp,
        size: 183,
        mobSize: 120,
    }
]

export const FEATURES = [
    {
        id: 0,
        title: 'No Cookie dependency',
        description: 'Reduce the guesswork around targeting criteria and the miss match of user persona and targeting criteria other tools provide.',
        label: '01',
    },
    {
        id: 1,
        title: "Competitors' clients are just a click away",
        description: 'Win your competitors users, run loyalty and retention campaigns, segment users by their interests and the websites they browse.',
        label: '02',
    },
    {
        id: 2,
        title: '20% Cheaper than all other ad platforms',
        description: 'Deploy the latest innovations in the field of AI in Ad tech for the benefit your campaigns. Save advertising dollars and create highly valuable campaigns',
        label: '03',
    },
    {
        id: 3,
        title: 'Integration and Reporting API',
        description: 'Our API is available for integration with any analytics and reporting platform you may be using',
        label: '04',
    },
    {
        id: 4,
        title: 'Pay-as-you-go',
        description: 'Our pay-as-you-go model makes it easy for businesses of all sizes to access our expert ad technology and enjoy maximum ROI without breaking the bank.',
        label: '05',
    },
    {
        id: 5,
        title: <>360<span>&#176;</span> Support</>,
        description: 'We are committed to providing our clients with the best possible experience. Whether you need help setting up your account, optimizing your ads, or troubleshooting any issues, we are here to help.',
        label: '06',
    }
];

